import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EmojiSadAngryIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsx("path", {
                            d: "M12.5 23c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm0-2a9 9 0 110-18 9 9 0 010 18zm.1-8c2.798 0 4.8 1.564 5.795 3.553a1 1 0 01-1.79.894C15.92 16.077 14.543 15 12.6 15c-2.11 0-3.514 1.064-4.206 2.447a1 1 0 11-1.788-.894C7.609 14.545 9.649 13 12.6 13zm-4.1-1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM18 10a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M8.5 6L11 8.5M16.5 6L14 8.5",
                            stroke: "#69717A",
                            strokeWidth: "2",
                            strokeLinecap: "round"
                        })
                    ]
                })
            })
        ]
    });
};
EmojiSadAngryIcon.isCarinaIcon = true;
export default EmojiSadAngryIcon;
